import React from "react";
import logo from "./logo.svg";
import { Grid } from "@material-ui/core";
import "./App.css";
import Container from "@material-ui/core/Container";
import SearchResult from "./components/search-result";
import Typography from "@material-ui/core/Typography";
import { SnackbarProvider } from "notistack";
import { BrowserRouter, Router, Route } from "react-router-dom";
import SearchOffer from "./components/search-offer";

require("./assets/css/style.css");

function App() {
  return (
    <SnackbarProvider maxSnack={3}>
      <BrowserRouter>
        <div>
          <Route
            path="/search"
            exact
            render={() => (
              <div className="main-container">
                <div className="root-class">
                  {/* <SearchHeader /> */}
                  <Container maxWidth={false}>
                    <Typography
                      component="div"
                      style={{ backgroundColor: "#transparent" }}
                    >
                      <SearchResult />
                    </Typography>
                  </Container>
                </div>
                <br />
                {/* <div className="offer-container">
                  <Typography className="root2-class" component="div">
                    <Grid container spacing={1}>
                      <Grid item xs={12}>
                        <Grid container spacing={1}>
                          <Grid className="files-icon-class" item xs={1}>
                            <img
                              src={require("./assets/images/officeicon.png")}
                            />
                          </Grid>
                          <Grid className="file-title-p" item xs={10}>
                            <p className="news-title">办事服务</p>
                            <div className="bottom-border"></div>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <SearchOffer />
                        </Grid>
                        <Grid item xs={12}>
                          <div className="bottom-page">
                            <img
                              style={{ width: "50px" }}
                              src={require("./assets/images/lefticon.png")}
                            />
                            <img
                              style={{ width: "50px" }}
                              src={require("./assets/images/right.png")}
                            />
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Typography>
                </div> */}
              </div>
            )}
          ></Route>
        </div>
      </BrowserRouter>
    </SnackbarProvider>
  );
}

export default App;
